import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    index_data: null,
    loading: true,
    error: false,
    refresh: null,
    selected_chat: null,
    add_mode: true,
    chat: [],
    chat_loading: false
};

const indexSlice = createSlice({
    initialState,
    name: "index_data",
    reducers: {
        set_index_data: (state, action) => {
            state = {
                ...state,
                ...action.payload
            }
            return state
        },
        reset_index_data: (state, action) => {

            return initialState
        },

    }
})

export default indexSlice.reducer;

export const {
    set_index_data,
    reset_index_data,
} = indexSlice.actions;
